export default {
    PORTAL_TARGET_NAME_POPUP: 'popup',
    WFM_DATAPROVIDER_API_URL: '',
    DREMIO_API_URL: '',
    DREMIO_UI_URL: '',
    LOCALE: 'ru',
    ERROR_MANAGER_WINDOW_ERROR_EVENT: 'error-handled',
    LICENSE_TOKEN_HEADER_KEY: 'X-License-Token'
};
